import React from 'react';
import { useWindowSize } from 'common/hooks';
import HomepageAsset from 'public/screens/Home/Components/Asset';
import { unwrapContentfulFields, ContentfulImage } from 'common/components';

export const useImageSelection = () => {
  const { isMobile } = useWindowSize();

  const getImageComponent = ({
    asset = null,
    mobileImage,
    defaultImage,
    ImageComponent = ContentfulImage,
    className,
    isHomepageAsset = false,
    style = {},
    poster = null,
  }) => {
    if (isHomepageAsset || (asset && asset.type)) {
      return (
        <HomepageAsset
          asset={asset ? unwrapContentfulFields(asset) : asset}
          className={className}
          poster={poster}
          style={style}
        />
      );
    }

    if (asset) {
      return (
        <HomepageAsset
          asset={unwrapContentfulFields(asset)}
          className={className}
          poster={poster}
          style={style}
        />
      );
    }

    if (mobileImage && isMobile) {
      return <ImageComponent field={mobileImage} className={className} />;
    }

    return <ImageComponent field={defaultImage} className={className} />;
  };

  return { getImageComponent };
};
